var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_awesome-eye",
    "data-name": "Icon awesome-eye",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.746,
    height: 13.164,
    viewBox: "0 0 19.746 13.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye-2",
    "data-name": "Icon awesome-eye",
    d: "M19.627,10.582A11,11,0,0,0,9.873,4.5,11,11,0,0,0,.119,10.582a1.109,1.109,0,0,0,0,1,11,11,0,0,0,9.754,6.082,11,11,0,0,0,9.754-6.082A1.109,1.109,0,0,0,19.627,10.582ZM9.873,16.019a4.937,4.937,0,1,1,4.937-4.937A4.937,4.937,0,0,1,9.873,16.019Zm0-8.228a3.267,3.267,0,0,0-.868.13,1.64,1.64,0,0,1-2.293,2.293A3.283,3.283,0,1,0,9.873,7.791Z",
    transform: "translate(0 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconView);
export default __webpack_public_path__ + "static/media/icon-view.7de49d3661f10f683c170dc1d0bce5bb.svg";
export { ForwardRef as ReactComponent };